import React,{useState, useEffect} from "react";
import {Container} from '@material-ui/core';
import {Link} from 'react-router-dom';
import translates from '../../translation.json';
import { lang } from "../../config/app.config";
import { useSelector } from 'react-redux';
import Menu from '../../models/menu.model'
import { routeFormatter } from "../../utils/common.utils";
interface Bprops {
  routes?:{
    path?:string,
    title:string,
  }[],
  slug?:string
}

interface state{
  menu:{
    menu:Menu,
    loading:boolean
  }
}

const Breadcrumb:React.FC<Bprops>=props=>{

  const {routes,slug} = props;

  const state =  useSelector((state:state)=>{
    const {menu} = state;
    return menu;
  });
  const {menu} = state;

  const [breadcrumb,setBreadcrumb] = useState<Array<Menu>|undefined>(undefined)

  // basic idea  parent children menu into single array ani find by parent id gardai breadcrumb ko list banako ani last ma reverse
  const handleBreadcrumb = ()=>{
    if(menu && menu.children && menu.children.length && slug){
      let all:Array<Menu> = [];
      let submenu = menu.children;
      const pushInAll = (m:Array<Menu>)=>{
        m.forEach(item=>{
          all.push(item);
          if(item.children && item.children.length){
            pushInAll(item.children);
          }
        })
      }
      pushInAll(submenu)
      // extract all menu items into one array
      
      //bread crumb array filter
      const currentPageMenu = all.find(item=>routeFormatter(item.key)=== routeFormatter(slug));

      let bArray:Array<Menu>  = [];

      const addParent = (p:Menu)=>{
        const temp = all.find(item=> item.id === p.parent_id);
        if(temp){
          bArray.push(temp);
          addParent(temp);
        }
      }

      if(currentPageMenu) {
        addParent(currentPageMenu);
        setBreadcrumb(bArray.reverse());
      };

    }
  }

  useEffect(()=>{
    handleBreadcrumb();
  },[menu])//eslint-disable-line

  return(
    <div className="ecn-breadcrumb bg-primary">
      <Container maxWidth="lg">
        <ul>
          <li>
            <Link to={"/"+lang}>{translates.translation[lang].home}</Link>
          </li>
          {
            breadcrumb?
              breadcrumb.map(item=>(
                <li key={item.id}>
                  <Link to={"/"+lang+ routeFormatter(item.key)}>{item.name}</Link>
                </li>
              ))
            :""
          }
          {
            routes && routes.map((route,i)=>(
              <li key={i}>
                {route.path?<Link to={'/'+lang+route.path}>{route.title}</Link>:<>{route.title}</>}
              </li>
            ))
          }
        </ul>
      </Container>
    </div>
  );
}

export default Breadcrumb;